var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _DiabguideRecommendationStartedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import DiabguideRecommendationComputedJournalEvent from "core/models/diabguide-recommendation-computed-journal-event";
import JournalEvent from "core/models/journal-event";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";

//---- Automatically generated, don't update this part ----
let DiabguideRecommendationStartedJournalEvent = (_dec = attr("number"), _dec2 = attr("number"), _dec3 = attr("number"), _dec4 = attr("number"), _dec5 = attr("number"), _dec6 = attr("number"), _dec7 = attr("string"), _dec8 = attr("number"), _dec9 = attr("string"), _dec10 = attr("string"), _dec11 = attr("string"), _dec12 = attr("string"), _dec13 = attr("string"), _dec14 = attr("string"), _dec15 = attr("string"), _dec16 = attr("boolean", {
  allowNull: true
}), _dec17 = attr("string"), _dec18 = attr("boolean", {
  allowNull: true
}), _dec19 = belongsTo("diabguide-recommendation-computed-journal-event", {
  async: false,
  inverse: "diabguideRecommendationStartedJournalEvent"
}), _class = (_DiabguideRecommendationStartedJournalEvent = class DiabguideRecommendationStartedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * age of the patient when call diabguide
     */
    _initializerDefineProperty(this, "age", _descriptor, this);
    /**
     * State of the patient, only if the patient's age > 75, 1 = good health, 2 = fragile, 3 = dependent
     */
    _initializerDefineProperty(this, "state", _descriptor2, this);
    /**
     * Height of the patient
     */
    _initializerDefineProperty(this, "height", _descriptor3, this);
    /**
     * Weight if the patient
     */
    _initializerDefineProperty(this, "weight", _descriptor4, this);
    /**
     * year of the diabete diagnostic
     */
    _initializerDefineProperty(this, "year", _descriptor5, this);
    /**
     * last HBA1C known
     */
    _initializerDefineProperty(this, "hba", _descriptor6, this);
    /**
     * Has MRC (all stade included)
     */
    _initializerDefineProperty(this, "mrc", _descriptor7, this);
    /**
     * DFG, only if have MRC = true
     */
    _initializerDefineProperty(this, "dfg", _descriptor8, this);
    /**
     * albuminurie/creatinurie ratio, only if mrc  = true
     */
    _initializerDefineProperty(this, "rac", _descriptor9, this);
    /**
     * has retinopathie
     */
    _initializerDefineProperty(this, "reti", _descriptor10, this);
    /**
     * has neuropathie
     */
    _initializerDefineProperty(this, "neur", _descriptor11, this);
    /**
     * has atheromatous disease
     */
    _initializerDefineProperty(this, "mcva", _descriptor12, this);
    /**
     * has heart failure
     */
    _initializerDefineProperty(this, "ic", _descriptor13, this);
    /**
     * ejection fraction of the patient
     */
    _initializerDefineProperty(this, "fevg", _descriptor14, this);
    /**
     * has other severe comorbidity
     */
    _initializerDefineProperty(this, "oth", _descriptor15, this);
    /**
     * has life expectation over 5 year
     */
    _initializerDefineProperty(this, "exp", _descriptor16, this);
    /**
     * has high blood pressure
     */
    _initializerDefineProperty(this, "hta", _descriptor17, this);
    /**
     * take merfomine
     */
    _initializerDefineProperty(this, "met", _descriptor18, this);
    _initializerDefineProperty(this, "diabguideRecommendationComputedJournalEvent", _descriptor19, this);
  }
  static validations(intl) {
    return {
      age: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.age")
      }), validateNumber({
        description: intl.t("validations.diabguide-recommendation-started-journal-event.age")
      })],
      height: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.height")
      }), validateNumber({
        description: intl.t("validations.diabguide-recommendation-started-journal-event.height")
      })],
      weight: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.weight")
      }), validateNumber({
        description: intl.t("validations.diabguide-recommendation-started-journal-event.weight")
      })],
      year: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.year")
      }), validateNumber({
        description: intl.t("validations.diabguide-recommendation-started-journal-event.year")
      })],
      hba: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.hba")
      }), validateNumber({
        description: intl.t("validations.diabguide-recommendation-started-journal-event.hba")
      })],
      mrc: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.mrc")
      }), validateInclusion({
        list: ["true", "false", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.mrc")
      })],
      reti: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.reti")
      }), validateInclusion({
        list: ["true", "false", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.reti")
      })],
      neur: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.neur")
      }), validateInclusion({
        list: ["true", "false", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.neur")
      })],
      mcva: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.mcva")
      }), validateInclusion({
        list: ["true", "false", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.mcva")
      })],
      ic: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.ic")
      }), validateInclusion({
        list: ["true", "false", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.ic")
      })],
      oth: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.oth")
      }), validateInclusion({
        list: ["true", "false", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.oth")
      })],
      hta: [validatePresence({
        presence: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.hta")
      }), validateInclusion({
        list: ["yes", "no", "treated", "unknown"],
        description: intl.t("validations.diabguide-recommendation-started-journal-event.hta")
      })],
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.diabguide-recommendation-started-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      state: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.state")
      }),
      dfg: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.dfg")
      }),
      rac: validateInclusion({
        list: ["under_30", "between_30_and_300", "over_300"],
        allowBlank: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.rac")
      }),
      fevg: validateInclusion({
        list: ["under_40", "over_40", "unknown"],
        allowBlank: true,
        description: intl.t("validations.diabguide-recommendation-started-journal-event.fevg")
      })
    };
  }

  //---- End of generated code ----
}, _defineProperty(_DiabguideRecommendationStartedJournalEvent, "type", "diabguide-recommendation-started-journal-event"), _DiabguideRecommendationStartedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "age", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "height", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "weight", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "year", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hba", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "mrc", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "dfg", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "rac", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "reti", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "neur", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "mcva", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "ic", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "fevg", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "oth", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "exp", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "hta", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "met", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "diabguideRecommendationComputedJournalEvent", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DiabguideRecommendationStartedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.